import axios from 'axios'
import { BUSCAR_ROTAS_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import {montarURLFiltro} from '../../util/filtros';

export default function buscarRotasItinerario (pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  let url = `${URL}/rota/itinerario/disponiveis-internet/${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ROTAS_ITINERARIO,
        payload: response
      })
  );
}
